import { RouteObject } from "react-router";
import * as Sentry from "@sentry/react";
import PageError from "@/helpers/components/Errors/PageError";

export const LabRoutes: RouteObject = {
	path: "/lab/*",
	lazy: async () => {
		const { LabHome } = await import("@/components/Lab/LabHome");
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={({ error, componentStack, resetError }) => (
						<PageError
							error={error}
							componentStack={componentStack}
							reset={resetError}
						/>
					)}
				>
					<LabHome />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		// Main LabHome for the top-level tabs
		{
			index: true,
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "daily",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "samples",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "spot",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "search",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "reports",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
		{
			path: "edit",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome, // Ensures Edit subtabs are inside LabHome
				};
			},
			children: [
				{
					path: "group",
					lazy: async () => {
						const { LabEditGroup } = await import("@/components/Lab/LabEditGroup");
						return {
							Component: LabEditGroup,
						};
					},
				},
				{
					path: "analysis",
					lazy: async () => {
						const { LabEditAnalysis } = await import("@/components/Lab/LabEditAnalysis");
						return {
							Component: LabEditAnalysis,
						};
					},
				},
			],
		},
		{
			path: "settings",
			lazy: async () => {
				const { LabHome } = await import("@/components/Lab/LabHome");
				return {
					Component: LabHome,
				};
			},
		},
	],
};
